import React, { useMemo } from 'react';
import { TouchableOpacity, Image, ScrollView } from 'react-native';
import { router, useNavigation, usePathname } from 'expo-router';
import styled from '@emotion/native';
import { green, sand } from '@/shared/styles/colors';
import { MOBILE_MENU_ITEMS } from '@/shared/constants/navigation';
import MobileDrawerItem from './MobileMenuItem';
import { ROUTES } from '@/shared/constants/routes';
import { useGetUser } from '@/shared/hooks/useGetUser';
import { DrawerActions } from '@react-navigation/native';
import useStore from '@/stores/useStore';
import AddIcon from '../AddIcon';
import EditIcon from '../EditIcon';

/* DrawerContent is only used on iOS */
const DrawerContent = () => {
  const navigation = useNavigation();
  const currentPath = usePathname();
  const { user } = useGetUser();
  const isStylist = useStore((state) => state.isStylist);

  const mobileMenuItems = useMemo(() => {
    if (isStylist) {
      return MOBILE_MENU_ITEMS;
    } else {
      return MOBILE_MENU_ITEMS.filter(
        (item) => item.label !== 'Payment Portal',
      );
    }
  }, [isStylist]);

  const onClosePress = () => {
    navigation.dispatch(DrawerActions.closeDrawer());
  };

  return (
    <ScrollView
      bounces={false}
      style={{
        flex: 1,
        backgroundColor: sand,
      }}
    >
      <DrawerContentContainer>
        <CloseButton onPress={onClosePress}>
          <CloseIcon source={require('@/assets/images/CloseIcon.png')} />
        </CloseButton>
        <OuterImageContainer>
          <TouchableOpacity onPress={() => router.push(ROUTES.PROFILE.path)}>
            <ImageContainer>
              {user?.profilePicUrl ? (
                <>
                  <ProfileImage source={{ uri: user?.profilePicUrl }} />
                  <EditIconContainer>
                    <EditIcon size={32} />
                  </EditIconContainer>
                </>
              ) : (
                <AddIcon />
              )}
            </ImageContainer>
          </TouchableOpacity>
        </OuterImageContainer>
        {mobileMenuItems.map((item, index) => (
          <MobileDrawerItem
            key={item.label}
            label={item.label}
            route={item.route}
            leadingIcon={item.leadingIcon}
            trailingIcon={item.trailingIcon}
            isLast={index === mobileMenuItems.length - 1}
            isActive={
              typeof item.route === 'object' &&
              'path' in item.route &&
              item.route.path === currentPath
            }
          />
        ))}
      </DrawerContentContainer>
    </ScrollView>
  );
};

export default DrawerContent;

const DrawerContentContainer = styled.View({
  backgroundColor: sand,
  flex: 1,
});

const CloseButton = styled.TouchableOpacity({
  justifyContent: 'center',
  alignItems: 'center',
  alignSelf: 'flex-end',
  marginRight: 28,
  marginVertical: 16,
});

const CloseIcon = styled.Image({
  width: 24,
  height: 24,
  resizeMode: 'contain',
  tintColor: green,
});

const OuterImageContainer = styled.View({
  width: '100%',
  alignItems: 'center',
  marginBottom: 24,
});

const ImageContainer = styled.View({
  width: 152,
  height: 157,
  borderRadius: 6,
  justifyContent: 'center',
  alignItems: 'center',
});

const ProfileImage = styled.Image({
  width: '100%',
  height: '100%',
  borderRadius: 6,
});

const EditIconContainer = styled.View({
  position: 'absolute',
  bottom: 9,
  right: 6,
  borderRadius: 6,
});
